var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {}, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "exampleFormControlInput1"
    }
  }, [_vm._v("Enter your profile link")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.profile_link,
      expression: "profile_link"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "exampleFormControlInput1",
      "placeholder": "Ex: https://www.abc.com/profile"
    },
    domProps: {
      "value": _vm.profile_link
    },
    on: {
      "blur": _vm.$v.profile_link.$touch,
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.profile_link = $event.target.value;
      }
    }
  }), _vm.getError('profile_link') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" You need to provide profile link ")]) : _vm._e(), !_vm.$v.profile_link.url && _vm.$v.profile_link.error ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" Profile link should be a valid link ")]) : _vm._e()]), _c('br'), _c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "exampleFormControlInput1"
    }
  }, [_vm._v("Upload proof of data")]), _vm.getError('proof_file') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" You need to provide proof file ")]) : _vm._e(), _c('vue-dropzone', {
    ref: "myVueDropzone",
    attrs: {
      "id": "dropzone",
      "options": _vm.dropzoneOptions,
      "useCustomSlot": true
    },
    on: {
      "vdropzone-max-files-reached": _vm.maxFileReached,
      "vdropzone-removed-file": _vm.deleteFile,
      "vdropzone-files-added": _vm.sendFile
    }
  }, [_c('div', {
    staticClass: "dropzone-custom-content"
  }, [_c('h3', {
    staticClass: "dropzone-custom-title"
  }, [_c('button', {
    staticClass: "chooseBtn"
  }, [_vm._v("CHOOSE FILE")])]), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v(" Or drag image here ")])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }